import { styled } from '@mui/material';
import classNames from 'classnames';
import { forwardRef } from 'react';

interface IconProps extends Omit<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >,
  'onClick'
> {
  iconClass: string;
  color?: string;
}

const _Icon = forwardRef<HTMLElement, IconProps>(
  ({ iconClass, ...rest }, ref) => {
    return (
      <span ref={ref} {...rest}>
        <i className={iconClass}></i>
      </span>
    );
  }
);

export const Icon = styled(_Icon)((props) => ({
  display: 'inline-flex',
  padding: '4px',
  borderRadius: '4px',

  '& i': {
    margin: '2px',
    width: '20px',
    height: '20px',
    color: props.color ? props.color : 'var(--mui-palette-text-primary)',
  },
}));

/**
 * This NewIcon is replacing the existing Icon component.
 * This icon shouldn't be used for buttons.
 * In case you need clickable/hoverable color changing icon, use the IconButton component instead.
 * You CAN use it for showing tooltip on hover, but it shouldn't change it's styling on hover.
 * className is the class name of the icon, and except of the icon itself, should be used mainly for color changing.
 * Don't use the class name for changing the size of the icon.
 * @param className - The class name of the icon.
 * @returns A span element with the icon.
 */
export const NewIcon = ({
  iconClass,
  color,
}: {
  iconClass: string;
  color?: string;
}) => {
  return (
    <span className='inline-flex w-[24px] h-[24px] p-[2px]'>
      <i
        className={classNames(iconClass, 'w-[20px] h-[20px]')}
        style={{ color }}
      />
    </span>
  );
};
